import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'readableName',
  standalone: true,
})
export class RemoveIdSuffixPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) return value;
    
    // Remove the '_id' suffix if it exists.
    let result = value.replace(/_id$/, '');
    
    // Insert a space before any uppercase letter following a lowercase letter (for camelCase).
    result = result.replace(/([a-z])([A-Z])/g, '$1 $2');
    
    // Replace underscores with spaces.
    result = result.replace(/_/g, ' ');
    
    // Capitalize the first letter of each word.
    result = result.replace(/\b\w/g, (match) => match.toUpperCase());
    
    return result;
  }
}
